module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.7d561e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_lets-get_768.png
// module id = 3fnV
// module chunks = 0